export default __webpack_public_path__ + "static/chumchum-6ce8dcb4840cc40e51db18a2f5ef5ccc.png";